import React, {useEffect, useState, useRef} from "react";
import {OAuth2Client, OAuthStatusTypes} from "@trumpf/ux.utils";

const oauthClient = new OAuth2Client({
	// Url of the Identity Provider
	issuer: "https://identity-s.trumpf.com/oauth2",

	// The SPA's id. The SPA is registered with this id at the auth-server
	clientId: "1kffflasH4444COTiFmP8DDO9ywa",

	// set the scope for the permissions the client should request
	// Important: Request offline_access to get a refresh token
	scope: "openid",
});

const redirectToAuthCallbackUrl = () => {
	const {location} = window.top;
	const params = new URLSearchParams(location.search);
	const path = params.get("path");
	const cleanUrl = `${location.protocol}//${location.host}${location.pathname}?path=${path}`;
	if (window.top.location.href !== cleanUrl) {
		window.top.history.replaceState({}, document.title, cleanUrl);
	}
};

export const TrumpfOAuth = () => {
	const clientRef = useRef(oauthClient);
	const client = clientRef.current;

	const [isLoggedIn, setIsLoggedIn] = useState(client.getStatus() === OAuthStatusTypes.AUTHENTICATED);
	const [isPending, setIsPending] = useState(client.getStatus() === OAuthStatusTypes.PENDING);
	const [error, setError] = useState(client.getError());
	const [expiration, setExpiration] = useState(new Date(client.getTokenExpiration()));

	useEffect(() => {
		const update = () => {
			const status = client.getStatus();
			const token = client.getAccessToken();
			setIsLoggedIn(status === OAuthStatusTypes.AUTHENTICATED);
			setIsPending(status === OAuthStatusTypes.PENDING);
			setExpiration(new Date(client.getTokenExpiration()));
			console.log(`[OAUTH] status: ${status}`);
		};
		update();
		const unsubscribe = client.subscribe(update);
		return () => {
			unsubscribe();
		};
	}, [client]);

	useEffect(() => {
		if (!isPending) {
			redirectToAuthCallbackUrl();
		}
	}, [isLoggedIn, isPending]);

	const handleClickLogin = () => {
		setIsPending(true);
		client.login();
	};

	const handleClickLogout = () => {
		setIsPending(true);
		client.logout();
	};

	const handleClickDeleteToken = () => {
		client.deleteAccessToken();
	};

	return (
		<div
			style={{
				padding: "20px 15px",
				backgroundColor: "rgb(246, 249, 252)",
				boxShadow: "rgba(0, 0, 0, 0.1) 0 1px 3px 1px",
				borderRadius: "4px",
				marginBottom: "20px",
			}}
		>
			{isLoggedIn && !isPending && (
				<>
					<div
						style={{
							fontFamily: "var(--ux-font)",
							fontSize: "var(--ux-button-font-size)",
							fontWeight: "var(--ux-button-font-weight)",
						}}
					>
						Logged In
					</div>
					<br />
					<div className="ux-button-group">
						<button type="button" className="ux-button" onClick={handleClickLogout} disabled={isPending}>
							Logout
						</button>
						<button type="button" className="ux-button" onClick={handleClickDeleteToken} disabled={isPending}>
							Delete Token
						</button>
					</div>
					<div className="ux-u-margin-top-20">
						<div>Token expires at {expiration.toLocaleString()}</div>
					</div>
				</>
			)}
			{!isLoggedIn && (
				<>
					<div
						style={{
							fontFamily: "var(--ux-font)",
							fontSize: "var(--ux-button-font-size)",
							fontWeight: "var(--ux-button-font-weight)",
						}}
					>
						Logged Out
					</div>
					<br />
					<button type="button" className="ux-button" onClick={handleClickLogin} disabled={isPending}>
						Login
					</button>
					<div className="ux-u-margin-top-20">
						<div>Login at MyTRUMPF (QA) via Authorization Code Flow + PKCE</div>
					</div>
				</>
			)}
			{isPending && <div className="ux-horizontal-loader ux-u-margin-top-20" />}
		</div>
	);
};

export default TrumpfOAuth;
